import { defineMessages } from 'react-intl'

export default defineMessages({

  'af': {
    id: 'auth.signup.af',
    defaultMessage: 'Afghanistan',
  },

  'al': {
    id: 'auth.signup.al',
    defaultMessage: 'Albania',
  },

  'dz': {
    id: 'auth.signup.dz',
    defaultMessage: 'Algeria',
  },

  'as': {
    id: 'auth.signup.as',
    defaultMessage: 'American Samoa',
  },

  'ad': {
    id: 'auth.signup.ad',
    defaultMessage: 'Andorra',
  },

  'ao': {
    id: 'auth.signup.ao',
    defaultMessage: 'Angola',
  },

  'ai': {
    id: 'auth.signup.ai',
    defaultMessage: 'Anguilla',
  },

  'aq': {
    id: 'auth.signup.aq',
    defaultMessage: 'Antarctica',
  },

  'ag': {
    id: 'auth.signup.ag',
    defaultMessage: 'Antigua and Barbuda',
  },

  'ar': {
    id: 'auth.signup.ar',
    defaultMessage: 'Argentina',
  },

  'am': {
    id: 'auth.signup.am',
    defaultMessage: 'Armenia',
  },

  'aw': {
    id: 'auth.signup.aw',
    defaultMessage: 'Aruba',
  },

  'ac': {
    id: 'auth.signup.ac',
    defaultMessage: 'Ascension Island',
  },

  'au': {
    id: 'auth.signup.au',
    defaultMessage: 'Australia',
  },

  'at': {
    id: 'auth.signup.at',
    defaultMessage: 'Austria',
  },

  'az': {
    id: 'auth.signup.az',
    defaultMessage: 'Azerbaijan',
  },

  'bs': {
    id: 'auth.signup.bs',
    defaultMessage: 'Bahamas',
  },

  'bh': {
    id: 'auth.signup.bh',
    defaultMessage: 'Bahrain',
  },

  'bd': {
    id: 'auth.signup.bd',
    defaultMessage: 'Bangladesh',
  },

  'bb': {
    id: 'auth.signup.bb',
    defaultMessage: 'Barbados',
  },

  'by': {
    id: 'auth.signup.by',
    defaultMessage: 'Belarus',
  },

  'be': {
    id: 'auth.signup.be',
    defaultMessage: 'Belgium',
  },

  'bz': {
    id: 'auth.signup.bz',
    defaultMessage: 'Belize',
  },

  'bj': {
    id: 'auth.signup.bj',
    defaultMessage: 'Benin',
  },

  'bm': {
    id: 'auth.signup.bm',
    defaultMessage: 'Bermuda',
  },

  'bt': {
    id: 'auth.signup.bt',
    defaultMessage: 'Bhutan',
  },

  'bo': {
    id: 'auth.signup.bo',
    defaultMessage: 'Bolivia',
  },

  'ba': {
    id: 'auth.signup.ba',
    defaultMessage: 'Bosnia and Herzegovina',
  },

  'bw': {
    id: 'auth.signup.bw',
    defaultMessage: 'Botswana',
  },

  'br': {
    id: 'auth.signup.br',
    defaultMessage: 'Brazil',
  },

  'io': {
    id: 'auth.signup.io',
    defaultMessage: 'British Indian Ocean Territory',
  },

  'vg': {
    id: 'auth.signup.vg',
    defaultMessage: 'British Virgin Islands',
  },

  'bn': {
    id: 'auth.signup.bn',
    defaultMessage: 'Brunei',
  },

  'bg': {
    id: 'auth.signup.bg',
    defaultMessage: 'Bulgaria',
  },

  'bf': {
    id: 'auth.signup.bf',
    defaultMessage: 'Burkina Faso',
  },

  'bi': {
    id: 'auth.signup.bi',
    defaultMessage: 'Burundi',
  },

  'kh': {
    id: 'auth.signup.kh',
    defaultMessage: 'Cambodia',
  },

  'cm': {
    id: 'auth.signup.cm',
    defaultMessage: 'Cameroon',
  },

  'ca': {
    id: 'auth.signup.ca',
    defaultMessage: 'Canada',
  },

  'cv': {
    id: 'auth.signup.cv',
    defaultMessage: 'Cape Verde',
  },

  'ky': {
    id: 'auth.signup.ky',
    defaultMessage: 'Cayman Islands',
  },

  'cf': {
    id: 'auth.signup.cf',
    defaultMessage: 'Central African Republic',
  },

  'td': {
    id: 'auth.signup.td',
    defaultMessage: 'Chad',
  },

  'cl': {
    id: 'auth.signup.cl',
    defaultMessage: 'Chile',
  },

  'cn': {
    id: 'auth.signup.cn',
    defaultMessage: 'China',
  },

  'cx': {
    id: 'auth.signup.cx',
    defaultMessage: 'Christmas Island',
  },

  'cc': {
    id: 'auth.signup.cc',
    defaultMessage: 'Cocos (Keeling) Islands',
  },

  'co': {
    id: 'auth.signup.co',
    defaultMessage: 'Colombia',
  },

  'km': {
    id: 'auth.signup.km',
    defaultMessage: 'Comoros',
  },

  'cd': {
    id: 'auth.signup.cd',
    defaultMessage: 'Congo (DRC)',
  },

  'cg': {
    id: 'auth.signup.cg',
    defaultMessage: 'Congo (Republic)',
  },

  'ck': {
    id: 'auth.signup.ck',
    defaultMessage: 'Cook Islands',
  },

  'cr': {
    id: 'auth.signup.cr',
    defaultMessage: 'Costa Rica',
  },

  'hr': {
    id: 'auth.signup.hr',
    defaultMessage: 'Croatia',
  },

  'cy': {
    id: 'auth.signup.cy',
    defaultMessage: 'Cyprus',
  },

  'cz': {
    id: 'auth.signup.cz',
    defaultMessage: 'Czech Republic',
  },

  'dk': {
    id: 'auth.signup.dk',
    defaultMessage: 'Denmark',
  },

  'dj': {
    id: 'auth.signup.dj',
    defaultMessage: 'Djibouti',
  },

  'dm': {
    id: 'auth.signup.dm',
    defaultMessage: 'Dominica',
  },

  'do': {
    id: 'auth.signup.do',
    defaultMessage: 'Dominican Republic',
  },

  'tl': {
    id: 'auth.signup.tl',
    defaultMessage: 'East Timor',
  },

  'ec': {
    id: 'auth.signup.ec',
    defaultMessage: 'Ecuador',
  },

  'eg': {
    id: 'auth.signup.eg',
    defaultMessage: 'Egypt',
  },

  'sv': {
    id: 'auth.signup.sv',
    defaultMessage: 'El Salvador',
  },

  'gq': {
    id: 'auth.signup.gq',
    defaultMessage: 'Equatorial Guinea',
  },

  'er': {
    id: 'auth.signup.er',
    defaultMessage: 'Eritrea',
  },

  'ee': {
    id: 'auth.signup.ee',
    defaultMessage: 'Estonia',
  },

  'et': {
    id: 'auth.signup.et',
    defaultMessage: 'Ethiopia',
  },

  'fk': {
    id: 'auth.signup.fk',
    defaultMessage: 'Falkland Islands (Islas Malvinas)',
  },

  'fo': {
    id: 'auth.signup.fo',
    defaultMessage: 'Faroe Islands',
  },

  'fj': {
    id: 'auth.signup.fj',
    defaultMessage: 'Fiji',
  },

  'fi': {
    id: 'auth.signup.fi',
    defaultMessage: 'Finland',
  },

  'fr': {
    id: 'auth.signup.fr',
    defaultMessage: 'France',
  },

  'gf': {
    id: 'auth.signup.gf',
    defaultMessage: 'French Guiana',
  },

  'pf': {
    id: 'auth.signup.pf',
    defaultMessage: 'French Polynesia',
  },

  'tf': {
    id: 'auth.signup.tf',
    defaultMessage: 'French Southern Territories',
  },

  'ga': {
    id: 'auth.signup.ga',
    defaultMessage: 'Gabon',
  },

  'gm': {
    id: 'auth.signup.gm',
    defaultMessage: 'Gambia',
  },

  'ge': {
    id: 'auth.signup.ge',
    defaultMessage: 'Georgia',
  },

  'de': {
    id: 'auth.signup.de',
    defaultMessage: 'Germany',
  },

  'gh': {
    id: 'auth.signup.gh',
    defaultMessage: 'Ghana',
  },

  'gi': {
    id: 'auth.signup.gi',
    defaultMessage: 'Gibraltar',
  },

  'gr': {
    id: 'auth.signup.gr',
    defaultMessage: 'Greece',
  },

  'gl': {
    id: 'auth.signup.gl',
    defaultMessage: 'Greenland',
  },

  'gd': {
    id: 'auth.signup.gd',
    defaultMessage: 'Grenada',
  },

  'gp': {
    id: 'auth.signup.gp',
    defaultMessage: 'Guadeloupe',
  },

  'gu': {
    id: 'auth.signup.gu',
    defaultMessage: 'Guam',
  },

  'gt': {
    id: 'auth.signup.gt',
    defaultMessage: 'Guatemala',
  },

  'gg': {
    id: 'auth.signup.gg',
    defaultMessage: 'Guernsey',
  },

  'gn': {
    id: 'auth.signup.gn',
    defaultMessage: 'Guinea',
  },

  'gw': {
    id: 'auth.signup.gw',
    defaultMessage: 'Guinea-Bissau',
  },

  'gy': {
    id: 'auth.signup.gy',
    defaultMessage: 'Guyana',
  },

  'ht': {
    id: 'auth.signup.ht',
    defaultMessage: 'Haiti',
  },

  'hm': {
    id: 'auth.signup.hm',
    defaultMessage: 'Heard Island and McDonald Islands',
  },

  'hn': {
    id: 'auth.signup.hn',
    defaultMessage: 'Honduras',
  },

  'hk': {
    id: 'auth.signup.hk',
    defaultMessage: 'Hong Kong',
  },

  'hu': {
    id: 'auth.signup.hu',
    defaultMessage: 'Hungary',
  },

  'is': {
    id: 'auth.signup.is',
    defaultMessage: 'Iceland',
  },

  'in': {
    id: 'auth.signup.in',
    defaultMessage: 'India',
  },

  'id': {
    id: 'auth.signup.id',
    defaultMessage: 'Indonesia',
  },

  'iq': {
    id: 'auth.signup.iq',
    defaultMessage: 'Iraq',
  },

  'ie': {
    id: 'auth.signup.ie',
    defaultMessage: 'Ireland',
  },

  'im': {
    id: 'auth.signup.im',
    defaultMessage: 'Isle of Man',
  },

  'il': {
    id: 'auth.signup.il',
    defaultMessage: 'Israel',
  },

  'it': {
    id: 'auth.signup.it',
    defaultMessage: 'Italy',
  },

  'ci': {
    id: 'auth.signup.ci',
    defaultMessage: 'Ivory Coast',
  },

  'jm': {
    id: 'auth.signup.jm',
    defaultMessage: 'Jamaica',
  },

  'jp': {
    id: 'auth.signup.jp',
    defaultMessage: 'Japan',
  },

  'je': {
    id: 'auth.signup.je',
    defaultMessage: 'Jersey',
  },

  'jo': {
    id: 'auth.signup.jo',
    defaultMessage: 'Jordan',
  },

  'kz': {
    id: 'auth.signup.kz',
    defaultMessage: 'Kazakhstan',
  },

  'ke': {
    id: 'auth.signup.ke',
    defaultMessage: 'Kenya',
  },

  'ki': {
    id: 'auth.signup.ki',
    defaultMessage: 'Kiribati',
  },

  'kw': {
    id: 'auth.signup.kw',
    defaultMessage: 'Kuwait',
  },

  'kg': {
    id: 'auth.signup.kg',
    defaultMessage: 'Kyrgyzstan',
  },

  'la': {
    id: 'auth.signup.la',
    defaultMessage: 'Laos',
  },

  'lv': {
    id: 'auth.signup.lv',
    defaultMessage: 'Latvia',
  },

  'lb': {
    id: 'auth.signup.lb',
    defaultMessage: 'Lebanon',
  },

  'ls': {
    id: 'auth.signup.ls',
    defaultMessage: 'Lesotho',
  },

  'lr': {
    id: 'auth.signup.lr',
    defaultMessage: 'Liberia',
  },

  'ly': {
    id: 'auth.signup.ly',
    defaultMessage: 'Libya',
  },

  'li': {
    id: 'auth.signup.li',
    defaultMessage: 'Liechtenstein',
  },

  'lt': {
    id: 'auth.signup.lt',
    defaultMessage: 'Lithuania',
  },

  'lu': {
    id: 'auth.signup.lu',
    defaultMessage: 'Luxembourg',
  },

  'mo': {
    id: 'auth.signup.mo',
    defaultMessage: 'Macau',
  },

  'mk': {
    id: 'auth.signup.mk',
    defaultMessage: 'Macedonia (FYROM)',
  },

  'mg': {
    id: 'auth.signup.mg',
    defaultMessage: 'Madagascar',
  },

  'mw': {
    id: 'auth.signup.mw',
    defaultMessage: 'Malawi',
  },

  'my': {
    id: 'auth.signup.my',
    defaultMessage: 'Malaysia',
  },

  'mv': {
    id: 'auth.signup.mv',
    defaultMessage: 'Maldives',
  },

  'ml': {
    id: 'auth.signup.ml',
    defaultMessage: 'Mali',
  },

  'mt': {
    id: 'auth.signup.mt',
    defaultMessage: 'Malta',
  },

  'mh': {
    id: 'auth.signup.mh',
    defaultMessage: 'Marshall Islands',
  },

  'mq': {
    id: 'auth.signup.mq',
    defaultMessage: 'Martinique',
  },

  'mr': {
    id: 'auth.signup.mr',
    defaultMessage: 'Mauritania',
  },

  'mu': {
    id: 'auth.signup.mu',
    defaultMessage: 'Mauritius',
  },

  'yt': {
    id: 'auth.signup.yt',
    defaultMessage: 'Mayotte',
  },

  'mx': {
    id: 'auth.signup.mx',
    defaultMessage: 'Mexico',
  },

  'fm': {
    id: 'auth.signup.fm',
    defaultMessage: 'Micronesia',
  },

  'md': {
    id: 'auth.signup.md',
    defaultMessage: 'Moldova',
  },

  'mc': {
    id: 'auth.signup.mc',
    defaultMessage: 'Monaco',
  },

  'mn': {
    id: 'auth.signup.mn',
    defaultMessage: 'Mongolia',
  },

  'me': {
    id: 'auth.signup.me',
    defaultMessage: 'Montenegro',
  },

  'ms': {
    id: 'auth.signup.ms',
    defaultMessage: 'Montserrat',
  },

  'ma': {
    id: 'auth.signup.ma',
    defaultMessage: 'Morocco',
  },

  'mz': {
    id: 'auth.signup.mz',
    defaultMessage: 'Mozambique',
  },

  'mm': {
    id: 'auth.signup.mm',
    defaultMessage: 'Myanmar (Burma)',
  },

  'qn': {
    id: 'auth.signup.qn',
    defaultMessage: 'Nagorno-Karabakh Republic',
  },

  'na': {
    id: 'auth.signup.na',
    defaultMessage: 'Namibia',
  },

  'nr': {
    id: 'auth.signup.nr',
    defaultMessage: 'Nauru',
  },

  'np': {
    id: 'auth.signup.np',
    defaultMessage: 'Nepal',
  },

  'nl': {
    id: 'auth.signup.nl',
    defaultMessage: 'Netherlands',
  },

  'an': {
    id: 'auth.signup.an',
    defaultMessage: 'Netherlands Antilles',
  },

  'nc': {
    id: 'auth.signup.nc',
    defaultMessage: 'New Caledonia',
  },

  'nz': {
    id: 'auth.signup.nz',
    defaultMessage: 'New Zealand',
  },

  'ni': {
    id: 'auth.signup.ni',
    defaultMessage: 'Nicaragua',
  },

  'ne': {
    id: 'auth.signup.ne',
    defaultMessage: 'Niger',
  },

  'ng': {
    id: 'auth.signup.ng',
    defaultMessage: 'Nigeria',
  },

  'nu': {
    id: 'auth.signup.nu',
    defaultMessage: 'Niue',
  },

  'nf': {
    id: 'auth.signup.nf',
    defaultMessage: 'Norfolk Island',
  },

  'mp': {
    id: 'auth.signup.mp',
    defaultMessage: 'Northern Mariana Islands',
  },

  'no': {
    id: 'auth.signup.no',
    defaultMessage: 'Norway',
  },

  'om': {
    id: 'auth.signup.om',
    defaultMessage: 'Oman',
  },

  'pk': {
    id: 'auth.signup.pk',
    defaultMessage: 'Pakistan',
  },

  'pw': {
    id: 'auth.signup.pw',
    defaultMessage: 'Palau',
  },

  'ps': {
    id: 'auth.signup.ps',
    defaultMessage: 'Palestinian Territories',
  },

  'pa': {
    id: 'auth.signup.pa',
    defaultMessage: 'Panama',
  },

  'pg': {
    id: 'auth.signup.pg',
    defaultMessage: 'Papua New Guinea',
  },

  'py': {
    id: 'auth.signup.py',
    defaultMessage: 'Paraguay',
  },

  'pe': {
    id: 'auth.signup.pe',
    defaultMessage: 'Peru',
  },

  'ph': {
    id: 'auth.signup.ph',
    defaultMessage: 'Philippines',
  },

  'pn': {
    id: 'auth.signup.pn',
    defaultMessage: 'Pitcairn Islands',
  },

  'pl': {
    id: 'auth.signup.pl',
    defaultMessage: 'Poland',
  },

  'pt': {
    id: 'auth.signup.pt',
    defaultMessage: 'Portugal',
  },

  'pr': {
    id: 'auth.signup.pr',
    defaultMessage: 'Puerto Rico',
  },

  'qa': {
    id: 'auth.signup.qa',
    defaultMessage: 'Qatar',
  },

  'ro': {
    id: 'auth.signup.ro',
    defaultMessage: 'Romania',
  },

  'ru': {
    id: 'auth.signup.ru',
    defaultMessage: 'Russia',
  },

  'rw': {
    id: 'auth.signup.rw',
    defaultMessage: 'Rwanda',
  },

  're': {
    id: 'auth.signup.re',
    defaultMessage: 'Réunion',
  },

  'bl': {
    id: 'auth.signup.bl',
    defaultMessage: 'Saint Barthélemy',
  },

  'sh': {
    id: 'auth.signup.sh',
    defaultMessage: 'Saint Helena',
  },

  'kn': {
    id: 'auth.signup.kn',
    defaultMessage: 'Saint Kitts and Nevis',
  },

  'lc': {
    id: 'auth.signup.lc',
    defaultMessage: 'Saint Lucia',
  },

  'mf': {
    id: 'auth.signup.mf',
    defaultMessage: 'Saint Martin',
  },

  'pm': {
    id: 'auth.signup.pm',
    defaultMessage: 'Saint Pierre and Miquelon',
  },

  'vc': {
    id: 'auth.signup.vc',
    defaultMessage: 'Saint Vincent and the Grenadines',
  },

  'ws': {
    id: 'auth.signup.ws',
    defaultMessage: 'Samoa',
  },

  'sm': {
    id: 'auth.signup.sm',
    defaultMessage: 'San Marino',
  },

  'sa': {
    id: 'auth.signup.sa',
    defaultMessage: 'Saudi Arabia',
  },

  'sn': {
    id: 'auth.signup.sn',
    defaultMessage: 'Senegal',
  },

  'rs': {
    id: 'auth.signup.rs',
    defaultMessage: 'Serbia',
  },

  'sc': {
    id: 'auth.signup.sc',
    defaultMessage: 'Seychelles',
  },

  'sl': {
    id: 'auth.signup.sl',
    defaultMessage: 'Sierra Leone',
  },

  'sg': {
    id: 'auth.signup.sg',
    defaultMessage: 'Singapore',
  },

  'sk': {
    id: 'auth.signup.sk',
    defaultMessage: 'Slovakia',
  },

  'si': {
    id: 'auth.signup.si',
    defaultMessage: 'Slovenia',
  },

  'sb': {
    id: 'auth.signup.sb',
    defaultMessage: 'Solomon Islands',
  },

  'so': {
    id: 'auth.signup.so',
    defaultMessage: 'Somalia',
  },

  'za': {
    id: 'auth.signup.za',
    defaultMessage: 'South Africa',
  },

  'gs': {
    id: 'auth.signup.gs',
    defaultMessage: 'South Georgia and the South Sandwich Islands',
  },

  'kr': {
    id: 'auth.signup.kr',
    defaultMessage: 'South Korea',
  },

  'es': {
    id: 'auth.signup.es',
    defaultMessage: 'Spain',
  },

  'lk': {
    id: 'auth.signup.lk',
    defaultMessage: 'Sri Lanka',
  },

  'sr': {
    id: 'auth.signup.sr',
    defaultMessage: 'Suriname',
  },

  'sj': {
    id: 'auth.signup.sj',
    defaultMessage: 'Svalbard and Jan Mayen',
  },

  'sz': {
    id: 'auth.signup.sz',
    defaultMessage: 'Swaziland',
  },

  'se': {
    id: 'auth.signup.se',
    defaultMessage: 'Sweden',
  },

  'ch': {
    id: 'auth.signup.ch',
    defaultMessage: 'Switzerland',
  },

  'st': {
    id: 'auth.signup.st',
    defaultMessage: 'São Tomé and Príncipe',
  },

  'tw': {
    id: 'auth.signup.tw',
    defaultMessage: 'Taiwan',
  },

  'tj': {
    id: 'auth.signup.tj',
    defaultMessage: 'Tajikistan',
  },

  'tz': {
    id: 'auth.signup.tz',
    defaultMessage: 'Tanzania',
  },

  'th': {
    id: 'auth.signup.th',
    defaultMessage: 'Thailand',
  },

  'tg': {
    id: 'auth.signup.tg',
    defaultMessage: 'Togo',
  },

  'tk': {
    id: 'auth.signup.tk',
    defaultMessage: 'Tokelau',
  },

  'to': {
    id: 'auth.signup.to',
    defaultMessage: 'Tonga',
  },

  'tt': {
    id: 'auth.signup.tt',
    defaultMessage: 'Trinidad and Tobago',
  },

  'ta': {
    id: 'auth.signup.ta',
    defaultMessage: 'Tristan da Cunha',
  },

  'tn': {
    id: 'auth.signup.tn',
    defaultMessage: 'Tunisia',
  },

  'tr': {
    id: 'auth.signup.tr',
    defaultMessage: 'Turkey',
  },

  'tm': {
    id: 'auth.signup.tm',
    defaultMessage: 'Turkmenistan',
  },

  'tc': {
    id: 'auth.signup.tc',
    defaultMessage: 'Turks and Caicos Islands',
  },

  'tv': {
    id: 'auth.signup.tv',
    defaultMessage: 'Tuvalu',
  },

  'um': {
    id: 'auth.signup.um',
    defaultMessage: 'U.S. Minor Outlying Islands',
  },

  'vi': {
    id: 'auth.signup.vi',
    defaultMessage: 'U.S. Virgin Islands',
  },

  'ug': {
    id: 'auth.signup.ug',
    defaultMessage: 'Uganda',
  },

  'ua': {
    id: 'auth.signup.ua',
    defaultMessage: 'Ukraine',
  },

  'ae': {
    id: 'auth.signup.ae',
    defaultMessage: 'United Arab Emirates',
  },

  'gb': {
    id: 'auth.signup.gb',
    defaultMessage: 'United Kingdom',
  },

  'us': {
    id: 'auth.signup.us',
    defaultMessage: 'United States',
  },

  'uy': {
    id: 'auth.signup.uy',
    defaultMessage: 'Uruguay',
  },

  'uz': {
    id: 'auth.signup.uz',
    defaultMessage: 'Uzbekistan',
  },

  'vu': {
    id: 'auth.signup.vu',
    defaultMessage: 'Vanuatu',
  },

  'va': {
    id: 'auth.signup.va',
    defaultMessage: 'Vatican City',
  },

  've': {
    id: 'auth.signup.ve',
    defaultMessage: 'Venezuela',
  },

  'vn': {
    id: 'auth.signup.vn',
    defaultMessage: 'Vietnam',
  },

  'wf': {
    id: 'auth.signup.wf',
    defaultMessage: 'Wallis and Futuna',
  },

  'eh': {
    id: 'auth.signup.eh',
    defaultMessage: 'Western Sahara',
  },

  'ye': {
    id: 'auth.signup.ye',
    defaultMessage: 'Yemen',
  },

  'zm': {
    id: 'auth.signup.zm',
    defaultMessage: 'Zambia',
  },

  'zw': {
    id: 'auth.signup.zw',
    defaultMessage: 'Zimbabwe',
  },

  'ax': {
    id: 'auth.signup.ax',
    defaultMessage: 'Åland Islands',
  },

  'bq': {
    id: 'auth.signup.bq',
    defaultMessage: 'Bonaire, Sint Eustatius and Saba',
  },

  'bv': {
    id: 'auth.signup.bv',
    defaultMessage: 'Bouvet Island',
  },

  'cw': {
    id: 'auth.signup.cw',
    defaultMessage: 'Curaçao',
  },

  'xk': {
    id: 'auth.signup.xk',
    defaultMessage: 'Kosovo',
  },

  'sx': {
    id: 'auth.signup.sx',
    defaultMessage: 'Sint Maarten (Dutch part)',
  },

  'ss': {
    id: 'auth.signup.ss',
    defaultMessage: 'South Sudan',
  },

  'cu': {
    id: 'auth.signup.cu',
    defaultMessage: 'Cuba',
  },

  'ir': {
    id: 'auth.signup.ir',
    defaultMessage: 'Iran',
  },

  'sy': {
    id: 'auth.signup.sy',
    defaultMessage: 'Syria',
  },

  'sd': {
    id: 'auth.signup.sd',
    defaultMessage: 'Sudan',
  },

})



// WEBPACK FOOTER //
// ./src/components/forms/CountrySelector/countries.js